import { t } from 'i18next';
import { TableFreeDevices } from '../Tables/TableFreeDevices';
import { SimpleButton } from '../styles';
import { PanelTitle } from './styles';
import { FreeDevExtraInfo } from '../ClientPanel';

export type DevicesPanelProps = {
  state: {
    freeDevs: FreeDevExtraInfo[];
  };
  openAssociateDevs: () => void;
  checkedDevs: FreeDevExtraInfo[];
  render: () => void
}
export const DevicesPanel = ({
  state,
  checkedDevs,
  openAssociateDevs,
  render,
}: DevicesPanelProps): JSX.Element => (
  <>
    <PanelTitle>{t('dispositivosNaoAssociados')}</PanelTitle>
    <SimpleButton
      style={{ fontSize: '80%' }}
      variant={checkedDevs.length ? 'primary' : 'disabled'}
      onClick={() => (checkedDevs.length ? openAssociateDevs() : null)}
    >
      {t('associar')}
    </SimpleButton>
    <TableFreeDevices freeDevs={state.freeDevs} selectionChanged={() => render()} />
  </>
);
